import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Fängt Render-/Lifecycle-Fehler ab, statt die App auf Schwarz zu reißen. */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="fatal-error">
          <h1>
            ADS-B <span className="accent">TRACKER</span>
          </h1>
          <p>Da ist etwas schiefgelaufen:</p>
          <pre className="mono">{this.state.error.message}</pre>
          <button onClick={() => location.reload()}>NEU LADEN</button>
        </div>
      );
    }
    return this.props.children;
  }
}
